import { useEffect, useState } from "react";

import isEquipeChatMobileApp, {
  isDesktopDevice,
} from "../utils/isEquipeChatMobileApp";
import isEquipeChatDesktopShell from "../utils/isEquipeChatDesktopShell";

const DISPLAY_MODE_QUERIES = [
  "(display-mode: standalone)",
  "(display-mode: window-controls-overlay)",
  "(display-mode: fullscreen)",
];

const readIsStandalonePwa = () => {
  if (typeof window === "undefined") {
    return false;
  }

  // 23/09/2026 — NUM COMPUTADOR o PWA instalado tem que se comportar igual ao
  // Chrome, e no Chrome isto aqui é false. Esta era a peça que faltava: mesmo
  // depois de corrigir o isEquipeChatMobileApp, o layout principal continuava
  // mobile por causa desta linha (`isMobile = !isDesktopAppLayout &&
  // (isStandalonePwa || isSmallDown)` em layout/index.js), porque o hook
  // pergunta direto ao navegador "estou instalado?" e o PC responde que sim.
  // Por isso reinstalar o PWA e limpar o cache não mudava nada.
  if (isDesktopDevice()) {
    return false;
  }

  if (window.navigator.standalone === true) {
    return true;
  }

  if (isEquipeChatDesktopShell()) {
    return false;
  }

  if (isEquipeChatMobileApp()) {
    return true;
  }

  return DISPLAY_MODE_QUERIES.some((query) => {
    try {
      return window.matchMedia(query).matches;
    } catch (_error) {
      return false;
    }
  });
};

const subscribeMediaQuery = (mediaQueryList, handler) => {
  if (!mediaQueryList) {
    return () => {};
  }

  if (typeof mediaQueryList.addEventListener === "function") {
    mediaQueryList.addEventListener("change", handler);
    return () => mediaQueryList.removeEventListener("change", handler);
  }

  if (typeof mediaQueryList.addListener === "function") {
    mediaQueryList.addListener(handler);
    return () => mediaQueryList.removeListener(handler);
  }

  return () => {};
};

const useIsStandalonePwa = () => {
  const [isStandalonePwa, setIsStandalonePwa] = useState(readIsStandalonePwa);

  useEffect(() => {
    if (typeof window === "undefined") {
      return undefined;
    }

    const updateStandaloneMode = () => {
      setIsStandalonePwa(readIsStandalonePwa());
    };

    const mediaQueryCleanups = DISPLAY_MODE_QUERIES.map((query) => {
      try {
        const mediaQueryList = window.matchMedia(query);
        return subscribeMediaQuery(mediaQueryList, updateStandaloneMode);
      } catch (_error) {
        return () => {};
      }
    });

    window.addEventListener("appinstalled", updateStandaloneMode);
    window.addEventListener("resize", updateStandaloneMode);

    return () => {
      mediaQueryCleanups.forEach((cleanup) => cleanup());
      window.removeEventListener("appinstalled", updateStandaloneMode);
      window.removeEventListener("resize", updateStandaloneMode);
    };
  }, []);

  return isStandalonePwa;
};

export default useIsStandalonePwa;
